import { render } from "./info-window.vue?vue&type=template&id=2f85388c"
import script from "./info-window.vue?vue&type=script&lang=js"
export * from "./info-window.vue?vue&type=script&lang=js"
script.render = render

export default script